import { memo, useCallback, useEffect, useState } from "react";
import ConnectivityIssue from "../Layout/ConnectivityIssue";
import Page from "./Page";
import Content from "./Content";
import HeadingV2 from "../HeaderV2";
import { getKnowledgeBaseContent } from "../../utilities/Response";
import { useDispatch, useSelector } from "react-redux";
import { addKnowledgeBase, resetKnowledgeBase, routeKnowledgeBase, setActivePageIds, setKnowledgeBaseSubPage } from "../../actions";
import { HubspotPage, KnowledgeBaseState } from "../../reducers/knowledgeBase.reducer";
import ErrorComponent from './Error';
import { CircularProgress } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

const KnowledgeBase = (props: { design: any }) => {

  const dispatch = useDispatch();

  const [search, setSearch] = useState('');
  const [isError, setIsError] = useState(false);
  const [loading, setLoader] = useState<boolean>(true);
  const [activePages, setActivePages] = useState<HubspotPage[]>([]);
  const knowledgeBase: KnowledgeBaseState = useSelector((state: any) => state.knowledgeBase);

  const getKnowledgeBase = useCallback(() => {
    getKnowledgeBaseContent()
      .then((content: any) => {
        if (!content || (content.name && content.name === 'AxiosError')) {
          throw new Error('Failed');
        }
        dispatch(addKnowledgeBase({ allPages: content.pages || [], urls: content.urls }));
      })
      .catch(err => {
        console.log(err);
        setIsError(true);
      })
      .finally(() => setLoader(false));

  }, [dispatch]);

  useEffect(() => {
    dispatch(routeKnowledgeBase('page'));
    dispatch(resetKnowledgeBase({ type: 'subpages' }));
    getKnowledgeBase()
  }, [getKnowledgeBase, dispatch]);

  useEffect(() => {
    if (knowledgeBase.activeRoute === 'content') {
      return;
    }

    if (!search) {
      setActivePages(
        knowledgeBase.activeRoute === 'page'
          ? knowledgeBase.allPages
          : knowledgeBase.subPages
      );
    } else {
      const pages = knowledgeBase.activeRoute === 'page'
        ? knowledgeBase.allPages
        : knowledgeBase.subPages;

      const searchedPages = pages.filter((page: HubspotPage) =>
        page.title.toLowerCase().includes(search.toLowerCase()) || page.description?.toLowerCase().includes(search.toLowerCase())
      );

      setActivePages(searchedPages);
    }

  }, [knowledgeBase.allPages, knowledgeBase.subPages, knowledgeBase.activeRoute, search]);

  const findPageById = (pages: HubspotPage[], searchId: string): HubspotPage | null => {
    for (const page of pages) {
      if (page.id === searchId) {
        return page;
      }

      const found = findPageById(page.pages, searchId);
      if (found) {
        return found;
      }
    }
    return null;
  };

  const onBackClick = () => {

    const activePageIds = [...knowledgeBase.activePageIds];
    const lastPage = activePageIds.pop();

    if (lastPage) {
      const page = findPageById(knowledgeBase.allPages, lastPage);

      if (page) {
        dispatch(routeKnowledgeBase('subpage'));
        dispatch(setKnowledgeBaseSubPage(page.pages))
        dispatch(setActivePageIds({ id: lastPage, type: 'remove' }))
      } else {
        dispatch(routeKnowledgeBase('page'));
        dispatch(resetKnowledgeBase({ type: 'subpages' }));
      }
    } else {
      dispatch(routeKnowledgeBase('page'));
      dispatch(resetKnowledgeBase({ type: 'subpages' }));
    }
  }
  return (
    <>
      <div className={`flex flex-col justify-start rounded-t-2xl font-mRegular min-w-96 px-4 pt-4 h-full overflow-hidden`} style={{ backgroundColor: props?.design?.backgroundColor }} id="chatWindow">
        <div id='ele-39' className="h-16 max-h-20 rounded-xl"><HeadingV2 type="Knowledge Base" backMethod={onBackClick} showBack={['content', 'subpage'].includes(knowledgeBase.activeRoute)} /></div>

        {
          loading
            ? <div id='ele-40' className="flex items-center justify-center h-full"><CircularProgress /></div>
            : isError
              ? <><ErrorComponent type="Knowledge Base" /></>
              : <>
                {
                  knowledgeBase.activeRoute !== 'content' &&
                  <>
                    {/* Search Box */}
                    <div id='ele-41' className="w-full mt-6 px-4 relative h-11">
                      <input
                        value={search}
                        id="bp-input-4"
                        placeholder={"Search categories"}
                        onChange={e => setSearch(e.target.value)}
                        className={`w-full outline-none font-mRegular text-base resize-none rounded-xl py-3 pl-8 pr-4 h-full text-primaryText bg-primaryBgColor`}
                      ></input>
                      
                      <SearchIcon id='ele-42' className="align-middle text-footer !text-lg absolute left-7 top-3 w-8"/>
                    </div>
                    <div id='ele-43' className="overflow-y-auto hide-scrollbar"> <Page design={props?.design} hubspotPages={activePages} /></div>
                  </>
                }

                {
                  knowledgeBase.activeRoute === 'content' &&
                  <div id='ele-44' className="overflow-y-auto hide-scrollbar h-full"> <Content /></div>
                }
              </>
        }


        <div className="position-fixed"> <ConnectivityIssue /> </div>
      </div>

    </>
  );
}

export default memo(KnowledgeBase);

